// src/utils/fetchSupabaseAll.js
import supabase from './supabase';

/**
 * 安定ソート＋件数上限付きの全件取得ユーティリティ
 * @param {string} tableName
 * @param {string} selectQuery
 * @param {number} [limit=1000] チャンクサイズ
 * @param {object} [options]
 * @param {string} [options.orderBy=\"id\"] order() に渡すカラム
 * @param {boolean} [options.ascending=true]
 * @param {number} [options.maxRows] 上限行数（超えたら打ち切り）
 */
export default async function fetchSupabaseAll(
  tableName,
  selectQuery,
  limit = 1000,
  { orderBy = "id", ascending = true, maxRows } = {}
) {
  let allData = [];
  let offset = 0;
  let hasMore = true;

  while (hasMore) {
    let query = supabase
      .from(tableName)
      .select(selectQuery)
      .order(orderBy, { ascending })
      .range(offset, offset + limit - 1);

    const { data: chunk, error } = await query;
    if (error) throw error;

    allData = allData.concat(chunk);
    offset += limit;
    if (!chunk || chunk.length < limit) hasMore = false;
    if (typeof maxRows === "number" && allData.length >= maxRows) {
      return allData.slice(0, maxRows);
    }
  }

  return allData;
}
